define('modules/order_table/order_table',['backbone', 'jquery', '_'], function (Backbone, $, _) {
  'use strict';
  function orderTable(el, collection) {
    if (el.data().orderBy === collection.params.order_by) {
      el.data().order = el.data().order === 'ASC' ? 'DESC' : 'ASC';
    }
    else {
      el.data().order = 'ASC';
    }
    var orderData = el.data(),
      order = {
        order_by: orderData.orderBy,
        order: orderData.order
      };
    collection.params = _.extend(collection.params, order);
    collection.fetch();
  }

  return orderTable;
});

